export function LeftArrow({
  title,
  className,
}: {
  title?: string
  className?: string
}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.24996 12.0608L8.71963 11.5304L5.89641 8.70722C5.50588 8.3167 5.50588 7.68353 5.89641 7.29301L8.71963 4.46978L9.24996 3.93945L10.3106 5.00011L9.78029 5.53044L7.31062 8.00011L9.78029 10.4698L10.3106 11.0001L9.24996 12.0608Z"
        fill="currentColor"
      />
    </svg>
  )
}
